import { defineStore } from 'pinia'
import { ref } from 'vue'

type ModalType = 'carousel' | 'booking'

export type BookingModalItem = {
  image: Media | null
  link: string
  title: string
  flexKey?: string
}

const MODAL_TYPES: Record<string, ModalType> = {
  CAROUSEL: 'carousel',
  BOOKING: 'booking',
}

export const useModalStore = defineStore('modal', () => {
  const data = ref<{ images: Media[]; bookings: BookingModalItem[] } | null>(null)
  const type = ref<ModalType | null>(null)

  const close = () => {
    type.value = null
    data.value = null
  }

  const openCarousel = (images: Media[]) => {
    type.value = MODAL_TYPES.CAROUSEL
    data.value = { bookings: [], images }
  }

  const openBooking = (bookings: BookingModalItem[]) => {
    type.value = MODAL_TYPES.BOOKING
    data.value = { bookings, images: [] }
  }

  return { TYPES: MODAL_TYPES, data, type, close, openCarousel, openBooking }
})
